/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-10 17:03:16
 * @LastEditors: caiqin.xie
 * @message: 推荐新闻列表
 */
import React from "react";
import NewsList from "../NewsList";
import styles from "../../index.module.scss";
import { INews } from "@/common/types";

interface IProps {
  newsList: INews[]; // 推荐新闻数据
  ctry: string;
  words: Record<string, string>;
  pageNum: number; // 当前页面 
  device: string;
}

const RecommendedNews = (props:IProps) => {
  const {newsList, ctry, words, pageNum, device} = props;
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  return (
    <>
      { ((newDevice === 'pc' && pageNum ===1) || newDevice !== 'pc') && (
        <section className={styles['section']}>
          <h2 className={styles['section-title']}>
            {words?.newsroom_title}
            {/* News recommendations */}
          </h2>
          <NewsList ctry={ctry} newsList={newsList}/>
        </section>
      )}
    </>
  )
}

export default RecommendedNews;
